import { FunctionComponent, ReactNode } from 'react';
import { Box, SxProps } from '@mui/material';

interface VerticalContainerProps {
    children: ReactNode;
    sx?: SxProps;
    containerName?: string;
}

// A container that arranges its children vertically
const VerticalContainer: FunctionComponent<VerticalContainerProps> = ({
    children,
    sx,
    containerName,
}) => {
    return (
        <Box
            data-testid={`${containerName}_vertical_container`}
            sx={{
                display: 'flex', // Use flexbox layout
                justifyContent: 'center', // Center content horizontally
                width: '100%', // Full width of the container
                boxSizing: 'border-box', // Include padding and border in the element's total width
                flexDirection: 'column', // Arrange children in a vertical direction
                ...sx,
            }}
        >
            {children}
        </Box>
    );
};

export default VerticalContainer;
